const listIdToKeyMap: Record<number, string[]> = {
  219880: ['all'], // virtual subscription key meaning "all possible subscriptions"
  287489: ['productAnnouncements'],
  287490: ['events', 'generalEvents', 'summitUserConference', 'atlasCampDeveloperConference'],
  287491: ['tipsTricksAndBestPractices', 'productRecommendations', 'specialOffers', 'marketplaceNewsletter'],
  1081095: ['jiraTechAlerts'],
  1081282: ['confluenceTechAlerts'],
  1081343: ['bambooTechAlerts'],
  1081388: ['crucibleTechAlerts'],
  1081451: ['cloverTechAlerts'],
  1081489: ['fisheyeTechAlerts'],
  1081543: ['crowdTechAlerts'],
  1231860: ['bitbucketPromotions'],
  1239131: ['jiraInsidersNewsletter'],
  1243499: ['developerEcosystemNewsletter'],
  1246925: ['confluenceInsidersNewsletter'],
  1267986: ['events', 'generalEvents', 'summitUserConference', 'atlasCampDeveloperConference'],
  1275007: ['gitInsidersNewsletter'],
  1370882: ['productSurveys'],
  1370962: ['jiraInsidersNewsletter'],
  1370965: ['gitInsidersNewsletter'],
  1370967: ['bitbucketTechAlerts'],
  1370968: ['hipchatTechAlerts'],
  1370971: ['jiraCoreTechAlerts'],
  1370973: ['jiraServiceDeskTechAlerts'],
  1370974: ['jiraSoftwareTechAlerts'],
  1382366: ['tipsTricksAndBestPractices'],
  1382367: ['tipsTricksAndBestPractices'],
  1382368: ['tipsTricksAndBestPractices'],
  1382369: ['tipsTricksAndBestPractices'],
  1382370: ['tipsTricksAndBestPractices'],
  1382371: ['tipsTricksAndBestPractices'],
  1382372: ['tipsTricksAndBestPractices'],
  1382373: ['tipsTricksAndBestPractices'],
  1382374: ['tipsTricksAndBestPractices'],
  1382375: ['tipsTricksAndBestPractices'],
  1382376: ['tipsTricksAndBestPractices'],
  1382377: ['tipsTricksAndBestPractices'],
  1382378: ['tipsTricksAndBestPractices'],
  1382379: ['tipsTricksAndBestPractices'],
  1382380: ['tipsTricksAndBestPractices'],
  1382381: ['tipsTricksAndBestPractices'],
  1395680: ['atlassianTeamPlaybook'],
  1397949: ['summitUserConference'],
  1401671: ['jiraServerNewsletter'],
  1402390: ['atlassianBlog'],
  1406704: ['summitUserConference'],
  1412633: ['developerEcosystemNewsletter'],
  1412722: ['devOpsDigest'],
  1412810: ['tipsTricksAndBestPractices'],
  1413519: ['atlassianCommunity'],
  1416115: ['atlassianCommunity'],
  1420843: ['atlasCampDeveloperConference'],
  1423233: ['tipsTricksAndBestPractices'],
  1423442: ['generalEvents'],
  1423449: ['atlassianTeamPlaybook'],
  1423487: ['productRecommendations'],
  1432855: ['jiraOps'],
};

export const mergeSubscriptionKeysWithLid = (
  source: string | undefined,
  keys: string | undefined,
  listId: number | undefined,
) => {
  if (source == null || source !== 'mc' || listId == null) {
    return keys;
  }

  const keysSet = keys == null ? new Set() : new Set(keys.split(','));

  const keyArray = listIdToKeyMap[listId];
  if (keyArray != null) {
    keyArray.forEach((keyElement) => {
      keysSet.add(keyElement);
    });
  }

  return Array.from(keysSet).join(',');
};
